import { Pipe, PipeTransform } from '@angular/core';
import { MediaGroup } from 'src/app/models/media/media-group.model';

@Pipe({
  name: 'filterMatchedCategoriesPipe',
  pure: false,
})
export class FilterMatchedCategoriesPipe implements PipeTransform {
  transform(mediaGroups: MediaGroup[]): any {
    return mediaGroups.filter((mediaGroup) => !mediaGroup.hasEmptyCategories);
  }
}
